import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { StoxlyClient } from '@stoxly/api-client';
import type { Body, Query } from '../op-types';

export function createInternalQueries(client: StoxlyClient) {
  return createQueryKeys('internal', {
    // ['internal', 'fundamentalsQuarterlyData', { query }]
    fundamentalsQuarterlyData: (query: Query<'internalFundamentalsGetQuarterlyData'>) => ({
      queryKey: [{ query }],
      queryFn: ({ signal }) =>
        client.internalFundamentalsGetQuarterlyData({ queries: query, signal }),
    }),
  });
}

/**
 * The edge-wire ingest pushes, as mutations.
 *
 * FAILURE THE `body` PARAMETER PREVENTS: every one of these routes reads a payload, but the
 * pre-zod document declared no `requestBody` at all, so these wrappers compiled while posting a
 * literal `undefined` — a call that can only ever 400. The zod migration published the bodies
 * the handlers always parsed; taking them as the mutation's variables is the only shape that
 * can actually reach the route.
 */
export function createInternalMutations(client: StoxlyClient) {
  return {
    fundamentalsIngestAdsRatio: {
      mutationFn: (body: Body<'internalFundamentalsIngestAdsRatio'>) =>
        client.internalFundamentalsIngestAdsRatio(body),
    },
    fundamentalsIngestExtraction: {
      mutationFn: (body: Body<'internalFundamentalsIngestExtraction'>) =>
        client.internalFundamentalsIngestExtraction(body),
    },
    fundamentalsIngestIssuerBalance: {
      mutationFn: (body: Body<'internalFundamentalsIngestIssuerBalance'>) =>
        client.internalFundamentalsIngestIssuerBalance(body),
    },
    fundamentalsNotifyUpdate: {
      mutationFn: (body: Body<'internalFundamentalsNotifyUpdate'>) =>
        client.internalFundamentalsNotifyUpdate(body),
    },
    insiderTransactionsIngest: {
      mutationFn: (body: Body<'internalInsiderTransactionsIngest'>) =>
        client.internalInsiderTransactionsIngest(body),
    },
    filingsIngestEvent: {
      mutationFn: (body: Body<'internalFilingsIngestEvent'>) =>
        client.internalFilingsIngestEvent(body),
    },
  };
}
